import React, { useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faSave, faXmark, faCheck, faFileLines } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from "react-redux";
import {fetchPageHeaderData} from '../../../slices/panelSlice/pageHeaderSlice'
import {fetchVariableList} from '../../../slices/panelSlice/variableListSlice'


const EditableTable = ({
  headers,
  rows,
  editRowId,
  editedData,
  handleEdit,
  handleSave,
  handleCancel,
  handleChange,
  editableFields,
  handleLog,
  editable
}) => {

    const dispatch = useDispatch();
    const { pageHeaderData, status, error } = useSelector((state) => state.pageHeader);
    const {variableList} = useSelector((state)=>state.variableList);

  useEffect(() => {
    dispatch(fetchPageHeaderData());
    dispatch(fetchVariableList())
  }, [dispatch]);

  return (
    <div className="tableContainer">
    <table className="table text-xs w-[88vw]" role="table">
        <thead className="stickyHeader bg-[var(--mainCol)] text-white">
        <tr>
          {headers?.map((header, index) => (
            <th className="p-1 text-left border" key={index}>
              {header.toUpperCase()}
            </th>
          ))}
          {editable && 
          <th className="p-1 text-left border">ACTION</th>
          }
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id}>
            {headers.map((header) => (
              <td
                key={header}
                style={{
                  padding: "12px",
                  border: "1px solid #ddd",
                  textAlign: "left",
                }}
              >
                {editRowId === row.id && editableFields.includes(header) ? (
                  // Conditional rendering for select inputs for "variable" and "variableIndex"
                  header === "variable" ? (
                    <select
                      value={editedData[header] || ""}
                      onChange={(e) => handleChange(e, header)}
                      style={{
                        width: "100%",
                        padding: "6px",
                        boxSizing: "border-box",
                        border: "1px solid",
                        color: "black",
                      }}
                    >
                      <option value="" disabled>Select Variable</option>
                      {variableList?.QuestionList.map(m=>{
                        return   <option key={m.id} value={m.title}>{m.title}</option>
                      })}
                    
                    
                    </select>
                  ) : header === "pagetitle" ? (
                    <select
                      value={editedData[header] || ""}
                      onChange={(e) => handleChange(e, header)}
                      style={{
                        width: "100%",
                        padding: "6px",
                        boxSizing: "border-box",
                        border: "1px solid",
                        color: "black",
                      }}
                    >
                      <option value="" disabled >Select Page Title</option>
                      {pageHeaderData?.result.map(m=>{
                        return   <option key={m.id} value={m.title}>{m.title}</option>
                      })}
                    </select>
                  ) : (
                    // Render input for other editable fields
                    <input
                      type="text"
                      value={editedData[header] || ""}
                      onChange={(e) => handleChange(e, header)}
                      onKeyUp={(e) => e.key === "Enter" && handleSave()}
                      style={{
                        width: "100%",
                        padding: "6px",
                        boxSizing: "border-box",
                        border: "1px solid",
                        color: "black",
                      }}
                    />
                  )
                ) : (
                  row[header] === true ? (
                    <FontAwesomeIcon
                      className="ml-2"
                      color="var(--green_Main)"
                      icon={faCheck}
                    />
                  ) : row[header] === false ? (
                    <FontAwesomeIcon
                      className="ml-2"
                      color="indianred"
                      icon={faXmark}
                    />
                  ) : (
                    String(row[header])
                  )
                )}
              </td>
            ))}
            {editable && 
                        <td style={{ border: "1px solid #ddd" }}>
              {editRowId === row.id ? (
                <div className="flex justify-center">
                  <FontAwesomeIcon
                    className="p-2 cursor-pointer"
                    color="#67a97b"
                    onClick={handleSave}
                    icon={faSave}
                  />
                  <FontAwesomeIcon
                    className="p-2 cursor-pointer"
                    color="indianred"
                    onClick={handleCancel}
                    icon={faXmark}
                  />
                </div>
              ) : (
                <div className="flex justify-center">
                  <FontAwesomeIcon
                    className="cursor-pointer"
                    onClick={() => handleEdit(row.id)}
                    icon={faPenToSquare}
                  />
                  <FontAwesomeIcon
                    className="ml-2 cursor-pointer"
                    onClick={() => handleLog(row.id)}
                    icon={faFileLines}
                  />
                </div>
              )}
            </td>
            }

          </tr>
        ))}
      </tbody>
    </table>
     </div>
  );
};

export default EditableTable;
